import {
  SERVICE_WISE_SLA_PAIN_MINUTES,
  SERVICE_WISE_SLA_PAIN_MINUTES_SUCCESS,
  SERVICE_WISE_SLA_PAIN_MINUTES_ERROR,
  SERVICE_WISE_SLA_PAIN_MINUTES_EMPTY,
} from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetServiceWiseSlaPainMinutes = (state = initialState, action) => {
  switch (action.type) {
    case SERVICE_WISE_SLA_PAIN_MINUTES:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SERVICE_WISE_SLA_PAIN_MINUTES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SERVICE_WISE_SLA_PAIN_MINUTES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SERVICE_WISE_SLA_PAIN_MINUTES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetServiceWiseSlaPainMinutes;
